import { useActiveCircleId } from '@/hooks/use-active-circle';
import { useConciergePermissions } from '@/hooks/use-concierge-permissions';
import { useReportConciergePermissions } from '@/libs/analytics/base-context-provider';
import { useEffect } from 'react';

/**
 * Reads the active circle's concierge permissions from below
 * `AnalyticsProvider` and reports them to `AnalyticsBaseContextProvider`.
 * Lives outside `libs/analytics` so that library never imports app hooks.
 */
export function ConciergePermissionsReporter() {
    const { canCreateConcierge, isPermissionsSettled } =
        useConciergePermissions();
    const { activeCircleId } = useActiveCircleId();
    const reportConciergePermissions = useReportConciergePermissions();

    useEffect(() => {
        reportConciergePermissions({
            circleId: activeCircleId,
            canCreateConcierge,
            isPermissionsSettled,
        });
    }, [
        reportConciergePermissions,
        activeCircleId,
        canCreateConcierge,
        isPermissionsSettled,
    ]);

    return null;
}
